/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

/**
 * Component.
 */
@Component({ name: 'count-summary-component' })
export default class extends Vue {
  /**
   * Property `icon`.
   */
  @Prop()
  icon: string;

  /**
   * Property `title`.
   */
  @Prop()
  title: string;

  /**
   * Property `counter`.
   */
  @Prop()
  counter: number;
}
